export function sumPrice(list: { price: number }[]): number {
	return list.reduce((total, item) => total + item.price, 0);
}
